"use client";

import { useEffect } from "react";

import { initMixpanel, mixpanelTrackPageview } from "@/shared/analytics/mixpanel";

/**
 * Fires the "Error 404 View" pageview once when the user lands on the
 * not-found boundary. resolvePageName in MixpanelProvider can't
 * distinguish a 404 from any other unknown pathname, so we trigger
 * explicitly from here to preserve legacy Mixpanel continuity.
 */
export function NotFoundTracker() {
  useEffect(() => {
    if (!initMixpanel()) return;
    mixpanelTrackPageview("Error 404 View");
  }, []);
  return null;
}
